<script setup lang="ts">
  import { VueFinalModal } from 'vue-final-modal';
  // Components
  import { UiModalHeader, IconImage } from '@/shared/ui';
  import DangerIcon from '@/shared/assets/icons/DangerIcon.svg';
  import ModalActions from '@/shared/ui/modals/ModalActions.vue';

  withDefaults(
    defineProps<{
      title: string;
      description: string;
      clickToClose?: boolean;
      escToClose?: boolean;
    }>(),
    {
      clickToClose: true,
      escToClose: true,
    }
  );

  const emit = defineEmits<{
    (e: 'confirm'): void;
    (e: 'close'): void;
  }>();

  const handleClose = () => {
    emit('close');
  };

  const handleConfirm = () => {
    emit('confirm');
  };
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    content-class="flex flex-col bg-white-01 rounded-2xl w-fit min-w-[320px] max-w-[min(90vw,440px)]"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    :click-to-close="clickToClose"
    :esc-to-close="escToClose"
  >
    <UiModalHeader
      class="px-5 pt-4 pb-2 text-sm"
      @close="handleClose"
    />
    <div
      id="modal-content"
      class="flex flex-col px-8 pb-7"
    >
      <IconImage
        :src="DangerIcon"
        alt="Danger"
        class="w-5 h-5 mb-4 mx-auto"
      />
      <p class="text-center text-base">
        {{ title }}
      </p>
      <p class="text-center text-base text-gray-03">
        {{ description }}
      </p>
      <ModalActions
        class="mt-6"
        @close="handleClose"
        @confirm="handleConfirm"
      />
    </div>
  </VueFinalModal>
</template>
